import { Component, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ParticipantService } from "../../services/participant.service";
import { ClientViewModel } from "../../models/client-view-model";
import { ClientService } from "../../services/client.service";
import { ParticipantViewModel } from "../../models/participant-view-model";
import { ActivatedRoute, Params } from "@angular/router";
import { ApiKeyViewModel } from "../../models/api-key-view-model";
import { ConfirmationDialogComponent } from "../../partials/confirmation-dialog/confirmation-dialog.component";
import { Select2OptionData } from "ng-select2";
import { ToastrService } from 'ngx-toastr';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { CreateResult } from '../../models/create-result';
import { ClientKeyNameViewModel } from '../../models/client-key-name-view-model';
import { ClientAccessKeyViewModel } from '../../models/client-access-key-view-model';


@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.scss']
})
export class ClientEditComponent implements OnInit {

  public selectedParticipants: string[] = [];
  public participants: Select2OptionData[];
  private allParticipants: ParticipantViewModel[];
  public clients: ClientViewModel[] = [];
  public select2options: any = {
    multiple: true,
    width: '100%'
  };
  public clientViewModel: ClientViewModel;
  public clientKeyNameViewModel: ClientKeyNameViewModel;
  public clientAccessKeyViewModel: ClientAccessKeyViewModel;
  public id: number;
  public keyName = '';
  public canAdd: boolean;
  public canEdit: boolean;
  public canAddEdit: boolean;
  public createResult: CreateResult;

  errorMessage: string;
  error: boolean;
  public heading: string;

  constructor(private _participantService: ParticipantService,
    private _clientService: ClientService,
    private _activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService) {

  }

  public async ngOnInit(): Promise<void> {

    this._activatedRoute.params.subscribe(async (params: Params) => {
      debugger;
      try {
        this.allParticipants = await this._participantService.GetParticipantsByClient();
        this.participants = this.allParticipants.map(x => ({ id: x.id.toString(), text: x.name }));
      } catch (e) {
        this.allParticipants = [];
        this.participants = [];
      }

      if (params['id'] !== 'new') {
        this.id = params['id'];
        this.initClient();

        this.canAddEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditClient], []);

      }
      else {

        this.canAddEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddClient], []);

        this.clientViewModel = {
          participants: [],
          name: '',
          apiKeys: []
        }
        this.clientAccessKeyViewModel = {
          accessKey: '',
          clientId: 0
        }

        this.clientKeyNameViewModel = {
          clientId: 0,
          keyName: ''
        }

        this.heading = "Add new client";
      }


    });
  }

  private async  initClient(): Promise<void> {
    this.clientViewModel = await this._clientService.GetById(this.id);
    this.clientAccessKeyViewModel = {
      accessKey: '',
      clientId: 0
    }
    this.clientKeyNameViewModel = {
      clientId: 0,
      keyName: ''
    }
    for (const participant of this.clientViewModel.participants) {
      this.selectedParticipants.push(this.participants.find(x => x.id === participant.id.toString()).id);
    }

    this.heading = "Edit Client " + this.clientViewModel.name;
  }

  public async addNewApiKey(): Promise<void> {
    if (!this.canAddEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this.clientKeyNameViewModel.clientId = this.clientViewModel.id;
      this.clientKeyNameViewModel.keyName = this.keyName;
      const createAPIKeyResult = await this._clientService.CreateAPIKey(this.clientKeyNameViewModel);
      this.initClient();
      this.keyName = '';

      if (createAPIKeyResult.success) {
        const modalRef = this.modalService.open(ConfirmationDialogComponent, {
          windowClass: 'modal-fade-in',
          centered: false,
          size: 'xl',
          backdrop: 'static'
        });
        modalRef.componentInstance.showCancel = false;
        modalRef.componentInstance.title = 'Api Key Created';
        modalRef.componentInstance.message = `<p>Your API key has been created, Please save this key as you will not be able to access it once this dialog closes</p>
        <p>API Key: <b>Bearer ${createAPIKeyResult.signedAccessKey}</b></p>`;
        modalRef.componentInstance.acceptButtonText = 'Close';
      }
    }

  }

  public async deleteApiKey(key: ApiKeyViewModel): Promise<void> {
    if (!this.canAddEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      const modalRef = this.modalService.open(ConfirmationDialogComponent, {
        windowClass: 'modal-fade-in',
        centered: false,
        size: 'xl',
        backdrop: 'static'
      });
      modalRef.componentInstance.showCancel = true;
      modalRef.componentInstance.title = 'Delete API key';
      modalRef.componentInstance.message = '<p>Disable the usage of this API key, Are you sure you want to delete this api key?</p>';
      modalRef.componentInstance.acceptButtonText = 'Yes';
      modalRef.componentInstance.cancelButtonText = 'No';

      const result: boolean = await modalRef.result;
      if (result) {
        this.clientAccessKeyViewModel.accessKey = key.accessKey;
        this.clientAccessKeyViewModel.clientId = this.clientViewModel.id;
        await this._clientService.DeleteApiKey(this.clientAccessKeyViewModel);
        this.initClient();
      }
      this.keyName = '';
    }
  }

  public validateClientName(): boolean {
    if (!this.clientViewModel.name) {
      this.error = true;
      this.errorMessage = "Client name is required";

    } else {

      this.error = false;
      this.errorMessage = "";
    }

    return this.error;

  }

  public async save(): Promise<void> {
    debugger;
    if (!this.canAddEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      if (this.validateClientName() === false) {
        this.clientViewModel.participants = [];
        for (const participant of this.selectedParticipants) {
          this.clientViewModel.participants.push(this.allParticipants.find(x => x.id.toString() === participant));
        }


        if (!this.clientViewModel.id) {

          this.clients = await this._clientService.GetAllClients();

          var name = this.clientViewModel.name;
          var clientExist = false;

          //Check if Client name already exist.
          if (this.clients.length > 0) {
            this.clients.forEach(function (value) {
              if (value["name"].toString() == name) {
                clientExist = true;
              }
            });
          }

          if (clientExist) {
            this._toastService.error("Client with same name already exist.", "Error");
          } else {
            this.createResult = await this._clientService.Create(this.clientViewModel);
            if (this.createResult.success) {
              this._toastService.success(this.createResult.message, "Success");
            } else {
              this._toastService.error(this.createResult.message, "Error");
            }
          }

        } else {
          this.createResult = await this._clientService.Update(this.clientViewModel);
          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");
          } else {
            this._toastService.error(this.createResult.message, "Error");
          }
        }
      }
    }
  }

}
